import { Location } from '@angular/common';
import { HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HttpClientService } from '../../Services/http-client.service';
import { SessionService } from '../../Services/session.service';
import { AppSettings } from '../../app-settings';
import { EventService } from "../../Services/event.service";




@Component({
  selector: 'app-getting-started',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './getting-started.component.html',
  styleUrls: ['./getting-started.component.css'],
  providers: []
})

export class GettingStartedComponent implements OnInit, OnDestroy {
  @ViewChild('container', { static: false }) container: ElementRef;
  heading: string = "";
  previousSection: string = "";
  nextSection: string = "";
  searchValue: string = '';
  selectedItem: any;
  gettingStartedSub: Subscription;
  gettingStartedSections = [];
  totalSections: number = 0;
  content: any;
  section: string = "";
  searchKeyWord: string = "";
  showsearch: boolean = false;
  noResultsFound: boolean = false;
  indx: number = 0;
  scrolled: number = 0;
  variablesList = [];
  searchResults = [];
  riseActivity = AppSettings.riseactivity;
  previousIndex: number = 0;
  lastIndex: number;
  loader = AppSettings.loadingCircleImageURL;
  dataAvailable: boolean=false;
  minLengthError:boolean=false;
  searchIndex:number=0;
  scoreKey800:string;
  activityLink: any = this.domSanitizer.bypassSecurityTrustResourceUrl(this.riseActivity);
  searchMode:boolean = false;
  userInfoSubscription:Subscription;
  scoreKey={"name":"$code","value":""};
  htmlKeywords=["href","class","id","div","span","li","ol","target","table","tr","td","thead","tbody","img"];
  properties = [
    { "GS_Channel": "rise_menu", "GS_Reason": "gmat_planner" },
    { "GS_Channel": "rise_menu", "GS_Reason": "mock_test" },
    { "GS_Channel": "rise_menu", "GS_Reason": "post_queries" },
    { "GS_Channel": "rise_menu", "GS_Reason": "og_quizzes" },
    { "GS_Channel": "rise_menu", "GS_Reason": "live_sessions" },
    { "GS_Channel": "rise_menu", "GS_Reason": "sys_requirement" },
    { "GS_Channel": "rise_menu", "GS_Reason": "support_policies" },
    { "GS_Channel": "rise_menu", "GS_Reason": "ext_policies" }
  ];
  constructor( private domSanitizer: DomSanitizer, private httpClientService: HttpClientService, private sessionService: SessionService, private router: Router, private route: ActivatedRoute, private readonly location: Location, private eventService: EventService) {
    this.userInfoSubscription = this.sessionService.getUserInfo$.
    subscribe((data) =>
    {
      if(data != "")
      {

            this.scoreKey800=data.scoreKey800;
            if(data.scoreKey800!=null && data.scoreKey800!=undefined){
              this.scoreKey['value'] = data.scoreKey800;
              this.scoreKey800=data.scoreKey800;
          }
          else{
              this.scoreKey['value'] = " ";
              this.scoreKey800=" ";
          }
      }
    });

    window.onresize = (e) =>
    {
        let width = window.innerWidth;
        if(width>480){
          let rightContainer = document.getElementsByClassName('rightContainer')[0] as HTMLElement;
          rightContainer.classList.remove('slideLeft');
        }
    };
  }

  getSectionId(){
    let url = window.location.href;
    return url.slice(url.lastIndexOf('/')+1);
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
    this.indx = parseInt(params['index']);
    this.getData();
    });


  }

getData(){
      this.gettingStartedSub = this.sessionService.sharedGettingStartedSections.subscribe((d) => {
        this.gettingStartedSections = d;
        this.totalSections = this.gettingStartedSections.length;
        if(d){
        this.httpClientService.get(AppSettings.restApiUrl + '/api/public/getting_started/variables', new HttpHeaders()).subscribe(data => {
          this.dataAvailable=true;
          this.selectedItem = this.gettingStartedSections[this.indx];
          this.variablesList = data;
          this.variablesList.find(obj => {
            return obj.name === "$code"
          }).value = this.scoreKey800;

          this.getNextPreviousSection(this.indx);
          setTimeout(()=>{
            document.getElementsByClassName('heading')[0].innerHTML = this.replaceVariables(this.selectedItem.name);
            document.getElementsByClassName('body_container')[0].innerHTML = this.replaceVariables(this.selectedItem.content);
            let el = document.getElementsByClassName('outerContainer')[0] as HTMLElement;
            let navbar = document.getElementById("progress") as HTMLElement;
            let sticky = navbar.offsetTop;
            el.addEventListener('scroll', () => {
              var winScroll = document.getElementsByClassName('outerContainer')[0].scrollTop;
              var height = document.getElementsByClassName('outerContainer')[0].scrollHeight - document.getElementsByClassName('outerContainer')[0].clientHeight;
              this.scrolled = (winScroll / height) * 100;
              document.getElementById("myBar").style.width = this.scrolled + "%";
              if (winScroll >= sticky) {
                navbar.classList.add("sticky");
              } else {
                navbar.classList.remove("sticky");
              }
            });
            this.scrollToSection(this.indx);
            this.attachEvent();
          },50);
        });
      }
        });





}



generateUrl(index){
let url = this.router.createUrlTree(['getting-started',index]).toString();
this.location.go(url);
}

  getNextPreviousSection(index) {
    index = parseInt(index);
    if(!this.searchMode){
    if (index > 0 && index < this.totalSections - 1) {
      this.previousSection = this.gettingStartedSections[index - 1].name;
      this.nextSection = this.gettingStartedSections[index + 1].name;
    }
    else if (index == 0) {
      this.nextSection = this.gettingStartedSections[index + 1].name;
    }
    else if (index == this.totalSections - 1) {
      this.previousSection = this.gettingStartedSections[index - 1].name;
    }

  }
  else{

    this.searchIndex=index;
    if(this.searchResults.length>1){
    if (index > 0 && index < this.searchResults.length - 1) {
      this.previousSection = this.stripHTMLTags(this.searchResults[index - 1].name);
      this.nextSection = this.stripHTMLTags(this.searchResults[index + 1].name);
    }
    else if (index == 0) {
      this.nextSection = this.stripHTMLTags(this.searchResults[index + 1].name);
    }
    else if (index == this.searchResults.length - 1) {
      this.previousSection = this.stripHTMLTags(this.searchResults[index - 1].name);

    }
  }
  else{


  }
}

  }

  showPreviousSection(event, index) {

    index = parseInt(index);
    this.generateUrl(index-1);
    let eventName=this.gettingStartedSections[index-1]['eventName'];
    let properties={};
    properties['GS_Reason']=this.gettingStartedSections[index-1]['gsReason'];
    properties['GS_Channel']="internal_menu";

    this.eventService.track(eventName,properties);
    this.scrolled = 0;
    document.getElementById("myBar").style.width = this.scrolled + "%";
    this.selectedItem = this.gettingStartedSections[index - 1];
    document.getElementsByClassName('rightContainer')[0].classList.remove('animated', 'fadeIn', 'slideUp', 'slideDown');
      setTimeout(()=>{
        document.getElementsByClassName('heading')[0].innerHTML = this.replaceVariables(this.gettingStartedSections[index - 1].name);
        document.getElementsByClassName('body_container')[0].innerHTML = this.replaceVariables(this.gettingStartedSections[index - 1].content);
        this.attachEvent();
      },10);
      setTimeout(()=>{
          document.getElementsByClassName('rightContainer')[0].classList.add('animated','fadeIn', 'slideDown');
      },1);
      this.attachEvent();
      this.scrollToSection(index);

    this.indx = index - 1;
    this.getNextPreviousSection(this.indx);

  }
  showNextSection(event, index) {
      index = parseInt(index);
      this.generateUrl(index+1);
      let eventName=this.gettingStartedSections[index+1]['eventName'];
      let properties={};
      properties['GS_Reason']=this.gettingStartedSections[index+1]['gsReason'];
      properties['GS_Channel']="internal_menu";

      this.eventService.track(eventName,properties);

      this.scrolled = 0;
      document.getElementById("myBar").style.width = this.scrolled + "%";
      this.selectedItem = this.gettingStartedSections[index + 1];
        document.getElementsByClassName('rightContainer')[0].classList.remove('animated', 'fadeIn', 'slideUp', 'slideDown');
       setTimeout(() => {
        document.getElementsByClassName('heading')[0].innerHTML = this.replaceVariables(this.gettingStartedSections[index + 1].name);
        document.getElementsByClassName('body_container')[0].innerHTML = this.replaceVariables(this.gettingStartedSections[index + 1].content);
        this.attachEvent();
      }, 10);
        setTimeout(()=>{
            document.getElementsByClassName('rightContainer')[0].classList.add('animated', 'fadeIn','slideUp');
        },1);

        this.attachEvent();
        this.scrollToSection(index);

      this.indx = index + 1;
      this.getNextPreviousSection(this.indx);
  }

  replaceVariables(content) {
    for (let i = 0; i < this.variablesList.length; i++) {
      let re = new RegExp(this.variablesList[i]['name'].replace("$","\\$"),"gm");
      content = content.replace(re, this.variablesList[i]['value']);
    }
    return content;
  }
  closeSearch(event) {
    this.showsearch = false;
    document.getElementsByClassName('header')[0].classList.remove('sidebarParentHeader');
    (<HTMLElement>document.getElementById('search')).nodeValue = "";
    this.noResultsFound = false;
    this.searchResults = [];
    this.searchValue = null;
    this.searchMode = false;
    this.minLengthError=false;
  }
  showSearchField(event) {
    this.showsearch = true;
    this.searchMode = true;
    document.getElementsByClassName('header')[0].classList.add('sidebarParentHeader');
  }



  searchTerm(event) {
    var term = event.target.value;
    this.searchKeyWord = term;
    this.searchResults = [];
    if(this.searchKeyWord.length>3){
      this.minLengthError = false;
      if(!(this.htmlKeywords.indexOf(this.searchKeyWord)>-1) && (this.searchKeyWord.indexOf("."))){
        this.noResultsFound=false;
        if (this.searchKeyWord != undefined && this.searchKeyWord != null && this.searchKeyWord != ""){
          for (let i = 0; i < this.gettingStartedSections.length; i++) {
            let currentObject={};
            currentObject['eventName'] = this.gettingStartedSections[i].eventName;
            currentObject['gsReason'] = this.gettingStartedSections[i].gsReason;
            currentObject['count']=0;

            let regExp = new RegExp('((?!(<(.)*>))' + this.searchKeyWord.replace("\.","") + '(?!(<\/(.)*>)))', "gmi");

            currentObject['count'] += (this.gettingStartedSections[i].name.match(regExp) || []).length;
            currentObject['count'] += (this.stripHTMLTags(this.gettingStartedSections[i].content).match(regExp )|| []).length;

             currentObject['name'] = this.gettingStartedSections[i].name.replace(regExp, function(str){ return "<span class='high_light'>" + str + "</span>"});
             currentObject['content'] = this.gettingStartedSections[i].content.replace(regExp, function(str){ return "<span class='high_light'>" + str + "</span>"});

            this.searchResults.push(currentObject);
          }
          this.searchResults = this.searchResults.filter(item => item.count != 0);
          this.noResultsFound = ((this.showsearch == true) && (this.searchResults.length == 0)) ? true : false;
        }
        else {
          this.noResultsFound = true;
          this.searchResults = [];
        }
      }
      else{
        this.noResultsFound = true;
        this.searchResults = [];
      }
  }
  else{
    this.minLengthError=true;
  }
  }

  stripHTMLTags(value):string
  {
    if(value == null)
      return value;
    var regex = /(&nbsp;|<([^>]+)>)/ig;
    return value.replace(regex, '');
  }

  matchTags(value):string
  {
    if(value == null)
      return value;
    var regex = /(&nbsp;|<([^>]+)>)/ig;
    value.match(regex);
    let arrOfDom = value.exec(regex);
    let arrIndexes = [];
    for(let i=0; i < arrOfDom.length;i++){
      if(value.indexOf(arrOfDom[i]) > -1){
        arrIndexes.push(value.indexOf(arrOfDom[i]));
        value.splice(value.indexOf(arrOfDom[i]),arrOfDom.length);
      }
    }

    let x =  this.stripHTMLTags(value).replace(this.searchKeyWord,function(str){
      return "<span class='high_light'>"+str+"</span>";
    });
  }


  toggleWidth(event) {
    let size = {
      width: window.innerWidth || document.body.clientWidth,
      height: window.innerHeight || document.body.clientHeight
    }
    let x = document.getElementsByClassName('rightContainer')[0] as HTMLElement;
    if (size.width > 768) {
      if (x.classList.contains('fullWidth')) {
        x.classList.remove('fullWidth');
       (<HTMLElement>document.querySelector('.sidebar')).style.opacity = "1";
      } else {
        x.classList.add('fullWidth');
        setTimeout(() => {
          (<HTMLElement>document.querySelector('.sidebar')).style.opacity = "0";
        }, 300);
      }
    }else {
      let x = document.getElementsByClassName('sidebar')[0] as HTMLElement;
      let y = document.getElementsByClassName('rightContainer')[0] as HTMLElement;
      if(y.classList.contains('slideLeft')){
        y.classList.remove('slideLeft');
        x.classList.remove('maxWidth');
      }
      else{
        y.classList.add('slideLeft');
        x.classList.add('maxWidth');
      }
    }
  }
  showSection(event, index, sec) {
    if(!this.searchMode){
    this.generateUrl(index);
    let sidebar = document.getElementsByClassName('sidebar')[0] as HTMLElement;
    sidebar.classList.remove('sidebarOverlay');
    let event={};
    event['eventName']=this.gettingStartedSections[index].eventName;
    let eventName = this.selectedItem.eventName;
    let properties = {};
    properties['GS_Channel'] = "web_menu";
    properties['GS_Reason'] = this.gettingStartedSections[index].gsReason;
    this.eventService.track(event['eventName'],properties);
      index = parseInt(index);
      document.getElementsByClassName('rightContainer')[0].classList.remove('animated', 'fadeIn', 'slideUp', 'slideDown');
      this.indx = index;
      this.getNextPreviousSection(index);
      this.scrolled = 0;
      document.getElementById("myBar").style.width = this.scrolled + "%";
      this.selectedItem = sec;
    setTimeout(() => {
      document.getElementsByClassName('heading')[0].innerHTML = this.replaceVariables(this.selectedItem.name);
      document.getElementsByClassName('body_container')[0].innerHTML = this.replaceVariables(this.selectedItem.content);
      this.attachEvent();
    }, 100);
      if (index > this.previousIndex) {
        setTimeout(() => {
          document.getElementsByClassName('rightContainer')[0].classList.add('animated', 'slideUp');
          this.scrollToSection(index);
        }, 10);
      }
      else if(index<this.previousIndex) {
        setTimeout(() => {
          document.getElementsByClassName('rightContainer')[0].classList.add('animated', 'slideDown');
          this.scrollToSection(index);
        }, 1);
      }
      else if(index==this.previousIndex){

      }
      this.previousIndex = index;
  }
  else{
    let currentItem = this.searchResults[index];
    let sidebar = document.getElementsByClassName('sidebar')[0] as HTMLElement;
    sidebar.classList.remove('sidebarOverlay');
    let eventName = currentItem.eventName;
    let properties = {};
    properties['GS_Channel'] = "web_menu";
    properties['GS_Reason'] = currentItem.gsReason;
    this.eventService.track(eventName,properties);
    setTimeout(() => {
      index = parseInt(index);
      document.getElementsByClassName('rightContainer')[0].classList.remove('animated', 'fadeIn', 'slideUp', 'slideDown');
      this.indx = index;
      this.searchIndex = index;
      this.getNextPreviousSection(this.searchIndex);
      this.scrolled = 0;
      document.getElementById("myBar").style.width = this.scrolled + "%";
      this.selectedItem = sec;
        setTimeout(() => {
      document.getElementsByClassName('heading')[0].innerHTML = this.replaceVariables(currentItem.name);
      document.getElementsByClassName('body_container')[0].innerHTML = this.replaceVariables(currentItem.content);
      this.attachEvent();
    },10);
      if (index > this.previousIndex) {
        setTimeout(() => {
          document.getElementsByClassName('rightContainer')[0].classList.add('animated', 'slideUp');
            this.scrollToSection(index);
        }, 1);
      }
      else if(index<this.previousIndex){
        setTimeout(() => {
          document.getElementsByClassName('rightContainer')[0].classList.add('animated', 'slideDown');
          this.scrollToSection(index);
        }, 1);
      }
      else if(index==this.previousIndex){


      }
      this.previousIndex = index;
    }, 20);
  }


  }
  scrollToSection(index) {
   if (index > 0 && index <= this.totalSections) {
      document.getElementsByClassName('outerContainer')[0].scrollTop = 100;
  }
  else {
     document.getElementsByClassName('outerContainer')[0].scrollTop = 0;
  }
  }
  attachEvent() {
      let elementCollection = document.getElementsByClassName('tablinksmt') as HTMLCollection;
      for (let j = 0; j < elementCollection.length; j++) {
        elementCollection[j].addEventListener('click', function(e) {
          let i, tabcontent, tablinks;
          let cityName = (<Element>e.target).attributes['data-text'].nodeValue;
          tabcontent = document.getElementsByClassName("tabcontent");
          for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = "none";
            let video =<HTMLVideoElement>(tabcontent[i].getElementsByTagName('video')[0]);
            if(video){
              video.pause();
            }

          }
          tablinks = document.getElementsByClassName("tablinksmt");
          for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" active_content", "");
          }
          document.getElementById(cityName).style.display = "block";
          (<Element>e.target).classList.add('active_content');
        });
      }
      if (<HTMLElement>elementCollection[0]) {
        (<HTMLElement>elementCollection[0]).click();
      }
  }



  openCity(event, cityName) {
    let i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active_content", "");
    }
    document.getElementById(cityName).style.display = "block";
    event.target.classList.add('active_content');
  }

  openMock(event, cityName) {
    let i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinksmt");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active_content", "");
    }
    document.getElementById(cityName).style.display = "block";
    event.target.classList.add('active_content');
  }


  getSection() {
    let x = this.router.url.slice(this.router.url.lastIndexOf('/') + 1, this.router.url.length);
    return x;
  }

  ngOnDestroy() {
    this.gettingStartedSub.unsubscribe();

  }

}